
/**
 * Custom component for New Years food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.2
 * @copyright  Copyright (C) 2024-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2024-12-09 (1.0.0) (jhoward)
 *      - <thanksgivingFoodItem> copied to <newYearsFoodItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <thanksgivingFoodItem>.
 *
 *    2025-12-03 (1.0.2) (jhoward)
 *      - Adjust visual styles in <newYearsFoodItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'new-years-food-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-inline'
    }
  },
})
